import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ConstructionBanner.module.scss';

export const ConstructionBanner: React.FC = () => {
  const { t } = useTranslation('banner');

  return (
    <div className={styles.banner} role="status">
      <span className={styles.dot} />
      <p className={styles.text}>{t('message')}</p>
    </div>
  );
};
